import './ContactUs.css';
import { useLanguage } from '../utils/LanguageContext';
import translations from './TermsOfService.lang.json';

const TermsOfService = () => {
  const { lang } = useLanguage(translations);

  return (
    <div className="contactUsTextContainer">
      <h2 className="contactUsTitle">{lang('termsOfServiceTitle')}</h2>
      <div className="contactUsTextContent">
        <p>{lang(`termsOfServiceParagraph1`)}</p>
        <p>
          <a href="/legalDocs/TOS.pdf" target="_blank" rel="noopener noreferrer">
            {lang('downloadTermsOfService')}
          </a>
        </p>
      </div>
    </div>
  );
};

export default TermsOfService;
